import React, { ReactElement, useCallback } from 'react';

import Icon, { Icons } from '@/components/atoms/Icon';
import { Container, IconContainer, Input } from './TextFieldInput.style';

export type TextFieldProps = {
    icon?: Icons;
    onChange?: (e: React.FormEvent<HTMLInputElement>) => void;
    placeholder?: string;
    value?: string;
};

const TextFieldInput = ({ icon, onChange, placeholder, value }: TextFieldProps): ReactElement => {
    const innerRef = React.useRef<HTMLInputElement>(null);

    const onClick = useCallback(() => {
        const input = innerRef.current;
        if (input) input.focus();
    }, [innerRef]);

    return (
        <Container onClick={onClick}>
            {icon ? (
                <IconContainer>
                    <Icon icon={icon} />
                </IconContainer>
            ) : null}

            <Input type="text" onChange={onChange} placeholder={placeholder} ref={innerRef} value={value} />
        </Container>
    );
};

export default TextFieldInput;
